import * as React from 'react';
import { SVGProps } from 'react';
export const CommunityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    viewBox="0 0 16 14"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M14.77 10.694a5.25 5.25 0 0 0-4.002-7.387 5.25 5.25 0 0 0-9.54 4.386L.801 9.147A1.25 1.25 0 0 0 2.353 10.7l1.453-.427c.452.207.931.348 1.423.42a5.254 5.254 0 0 0 6.964 2.58l1.453.427a1.25 1.25 0 0 0 1.552-1.552l-.427-1.454ZM3.876 8.719a.743.743 0 0 0-.212.03l-1.295.381.382-1.295a.75.75 0 0 0-.059-.563 3.75 3.75 0 1 1 1.54 1.536.75.75 0 0 0-.356-.089Zm9.43 1.55a.75.75 0 0 0-.058.563l.38 1.295-1.293-.377a.75.75 0 0 0-.566.059 3.75 3.75 0 0 1-4.831-1.144 5.245 5.245 0 0 0 4.284-5.71 3.75 3.75 0 0 1 2.087 5.312l-.003.002Z"
    />
  </svg>
);
